import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { PageLoading } from '@mkmp/core'
import { LayoutFooter } from '../components'
import '../styles/basic-layout.scss'

/**
 * 基础导航布局
 * @returns
 */
export const BasicLayout = () => {
  return (
    <section className="basiclayout">
      <div className="basiclayout-container">
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </div>
      <LayoutFooter />
    </section>
  )
}
